module.exports = __webpack_public_path__ + "59f8a50c89ddcbf116396d6e13e6f00a.pdf";